import {Tab} from '@common-module/app-enums/tab';

const TABS_WITHOUT_SIDENAV: readonly Tab[] = [
  Tab.ROUTES,
  Tab.RUNS,
  Tab.GEOFENCES,
  Tab.SEASON_CALENDAR,
];

/** Сохраняет правило оболочки: перечисленные разделы открываются без панели объектов. */
export function isRouteWithSideNav(url: string): boolean {
  return TABS_WITHOUT_SIDENAV.every(tab => !url.includes(tab));
}

/** В самостоятельных редакторах скрываем весь футер управления объектами, включая фон. */
export function isRouteWithFooter(url: string): boolean {
  const rootPath = url.split(/[?#]/)[0].split('/')[1];
  return ![Tab.ROUTES, Tab.RUNS, Tab.SEASON_CALENDAR].some(tab => tab === rootPath);
}
